import React, { useEffect, useState } from "react";
import Header from "../Header";
import BookSchedule from "../BookSchedule/BookSchedule";
import classes from "./DoctorProfile.module.css";
import "./DoctorProfile.scss";
import LoginModal from "./Login/LoginModal";
import UserBrowser from "../UserBrowser";
import GlobalFooter from "../GlobalFooter";
import { useHistory, useParams } from "react-router";
import moment from "moment";
import { isSlotAfterCurrentTime } from "../../Util/Helper/isSlotAfterCurrentTime";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import swal from "sweetalert";
import "../../globalStyles/main.css";
import { connect } from "react-redux";
import DoctorDetails from "./DoctorDetails";
import Calendar from "react-calendar";
import PatientLoginContainer from "./../PatientLoginContainerBooking";
import { Modal } from "react-bootstrap";
import CloseIcon from "../../assets/close_icon.png";
import Stepper from "./stepper";
import * as Steps from "./constants";
import LinkExpiredModal from "../InstantConsultation/Modal/LinkExpiredModal";
import Select, { components } from "react-select";
import { useCookies } from "react-cookie";
import useDisableHelp from "../../Hooks/useDisableHelp";
import CalendarClinicIcon from "../../assets/calendar-clinic.svg";
import DropdownIcon from "../../assets/dropdown.svg";
import ConsultationClinicIcon from "../../assets/consultation-clinic.svg";
import SelectClinic from "./SelectClinic2";
import clinic from "../../assets/selectClinic.svg";
import disableIcon from "../../assets/disableIcon.svg";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import { setDynamicCookieForUser } from "../../Util/API Calls/cookieHelper";

//Doctor Profile that Patient will see once they tries to book doctor
const DoctorProfile = (props) => {
  const options = [
    {
      id: 5,
      label: "In-Clinic Regular",
      value: "inclinic-regular",
    },
    {
      id: 6,
      label: "In-Clinic Follow-Up",
      value: "inclinic-follow-up",
    },
    {
      id: 0,
      label: "Tele-Consult Regular",
      value: "regular",
    },
    {
      id: 1,
      label: "Tele-Consult Follow-Up",
      value: "Follow-Up",
    },
  ];
  const history = useHistory();
  const { slug } = useParams();
  const [doctor, setDoctorDetails] = useState();
  const [selectedSlot, setSelectedSlot] = useState("");
  const [selectedDate, setSelectedDate] = useState({});
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [startTime, setStartTime] = useState("");
  const [followUpBooking, setFollowUpBooking] = useState(false);
  const [fees, setFees] = useState("");
  const [duration, setDuration] = useState("");
  const [emailVerify, setEmailVerify] = useState(false);
  const [counter, setCounter] = useState(0);
  const [fromCalender, setFromCalender] = useState(false);
  const [calenderDate, setCalenderDate] = useState(new Date());
  const [showCalendar, setShowCalendar] = useState(false);
  const [showPatientLoginModal, setShowPatientLoginModal] = useState(false);
  const [meetingId, setMeetingId] = useState(null);
  const [isLinkExpired, setIsLinkExpired] = useState(false);
  const [selectedProcedure, setselectedProcedure] = useState({});
  const [alternateNumber, setalternateNumber] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies(["cookie-name"]);
  const [clinicList, setClinicList] = useState([]);
  const [selectedClinic, setSelectedClinic] = useState(
    JSON.parse(sessionStorage.getItem("followUpSelectdClinic")) ?? null
  );
  const [procedures, setProcedures] = useState([]);
  const [consultation_type, setConsultationType] = useState(
    JSON.parse(sessionStorage.getItem("followUpConsultationType"))?.id
  );
  const [procedureId, setProcedureId] = useState();
  const [instruction, setInstruction] = useState();
  const [consultationList, setConsultationList] = useState([]);
  const [selectedConsultationType, setSelectedConsultationType] = useState();
  const [proceduresValue, setProceduresValue] = useState({});

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const isAssociated = localStorage.getItem(LOCALSTORAGEKEY.IS_ASSOCIATED);
  const styles = {
    control: (base) => ({
      ...base,
      width: "100% !important",
      // background: " #F5F6F7 0% 0% no-repeat padding-box",
      background: "none",
      boxShadow: "none",
      border: "none",
      cursor: "pointer",
      "&:hover": {
        boxShadow: "none",
      },
      height: 35,
      minHeight: 35,
      fontWeight: "bold",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "40px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      "@media only screen and (max-width: 767px)": {
        height: "36px",
      },
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: "19px",
      borderRadius: "0px",
      // background:"red",
      width: "288px",
      marginLeft: "-48px",
    }),

    menuList: (provided) => ({
      ...provided,
      cursor: "pointer",
      maxHeight: "200px",
      paddingTop: "0px",
      "&::-webkit-scrollbar": {
        width: "16px",
        height: " 16px",
        display: "block !important",
        background: "none",
      },
      "&::-webkit-scrollbar-track": {
        background: "none",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb": {
        boxShadow: "inset 0 0 16px rgba(240, 232, 232, 1)",
        minHeight: "60px !important",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#888",
        border: "none",
      },
    }),
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        // color: 'black',
        fontWeight: "bold",
      };
    },
  };

  let [track, changeTrack] = useState(1);
  const bookingButtonRef = React.useRef();
  const [videoUrl, setVideo] = useState(
    "https://www.youtube.com/embed/yYFOPYu_nKI"
  );

  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("meeting_id");
  useDisableHelp();
  useEffect(() => {
    setSelectedSlot("");
    localStorage.setItem("appointment_slot_locked", false);
  }, [selectedDate]);

  useEffect(() => {
    removeCookie("lastPathBeforeLogin", { path: "/" });
    if (id !== null) {
      setMeetingId(id);
      if (localStorage.getItem("meeting_id") !== null) {
        localStorage.removeItem("meeting_id");
      }
      afterLoginApiAxios({
        method: "post",
        url: "/public/instant_consult_status",
        data: {
          meeting_id: id,
        },
      })
        .then((res) => {
          let flag = res.data.data[0].is_cancelled;
          setDynamicCookieForUser(
            LOCALSTORAGEKEY.CLINIC_ID,
            res.data.data[0].clinic_id,
            setCookie
          );
          localStorage.setItem(
            LOCALSTORAGEKEY.CLINIC_ID,
            res.data.data[0].clinic_id
          );
          if (flag === "True") {
            setIsLinkExpired(true);
            localStorage.removeItem("meeting_id");
            localStorage.removeItem("instantFees");
          } else {
            if (localStorage.getItem("meeting_id") === null) {
              setMeetingId(id);
              localStorage.setItem("meeting_id", id);
              setTimeout(isLoggedIn, 2000);
            }
            if (res.data.statusCode === 200) {
              localStorage.setItem(
                "instantFees",
                res.data.data[0].visible_to_patient
              );
            }
          }
        })
        .catch((err) => C2CConsole.log(err));
    } else {
      if (localStorage.getItem("meeting_id") !== null) {
        localStorage.removeItem("meeting_id");
        localStorage.removeItem("instantFees");
      }
    }
    localStorage.removeItem("procedure_id");
  }, []);

  const isLoggedIn = () => {
    if (
      localStorage.getItem("id_token") &&
      localStorage.getItem("user_type") === "patient"
    ) {
      afterLoginApiAxios({
        method: "post",
        url: "/patient/patient_invitation_action",
        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: {
          patient_id: userId,
          event_id: 1,
          instant_consult_key: meetingId,
        },
      })
        .then((res) => {})
        .catch((err) => C2CConsole.log(err));
      history.push({
        pathname: "/appointments/book",
        state: { meeting_id: meetingId },
      });
    } else {
      history.replace(`/doctor/${slug}/login/`);
      setShowPatientLoginModal(true);
    }
  };

  const bookAppointment = () => {
    const isAfter = isSlotAfterCurrentTime(startTime, counter, selectedDate);
    if (!isAfter) {
      return swal({
        icon: "warning",
        title: "Booking time expired",
        text: "You're allowed to book 15 minutes earlier to the appointment start time",
      }).then(() => {
        window.location.reload();
      });
    }
    localStorage.removeItem("is_followup");
    if (
      localStorage.getItem("id_token") &&
      localStorage.getItem("user_type") == "patient"
    ) {
      bookAppointmentWithoutLogin();
      setFollowUpBooking(false);
    } else {
      history.replace(`/doctor/${slug}/login/`);
      setShowPatientLoginModal(true);
    }
  };

  const bookFollowup = () => {
    localStorage.removeItem("is_followup");
    setFollowUpBooking(true);
    if (
      localStorage.getItem("id_token") &&
      localStorage.getItem("user_type") == "patient"
    ) {
      bookAppointmentWithoutLogin(true);
      setFollowUpBooking(true);
    } else {
      history.replace(`/doctor/${slug}/login/`);
      setShowPatientLoginModal(true);
    }
  };

  const stopVideo = () => {
    setVideo("");
  };

  const startVideo = () => {
    setVideo("https://www.youtube.com/embed/yYFOPYu_nKI");
  };

  const bookAppointmentWithoutLogin = (followUpBooking) => {
    localStorage.setItem("slot_id", selectedSlot);
    localStorage.setItem("start", startTime);
    localStorage.setItem(
      "date",
      moment(selectedDate.meta).format("YYYY-MM-DD")
    );
    localStorage.setItem("doctor", JSON.stringify(doctor));
    if (followUpBooking) {
      return history.push("/appointment/select-patient/" + slug);
    } else {
      history.push("/appointments/book");
    }
  };

  const handleDate = (date) => {
    setCalenderDate(date);
    setFromCalender(true);
    setShowCalendar(false);
    changeTrack(++track);
  };

  const bookFollowUp = () => {
    if (
      localStorage.getItem("id_token") &&
      localStorage.getItem("user_type") === "patient"
    ) {
      bookAppointmentWithoutLogin(true);
    }
    setShowLoginModal(true);
    setFollowUpBooking(true);
  };

  const loginSuccessHandler = () => {
    if (localStorage.getItem("login_email")) {
      if (followUpBooking) history.push("/appointment/select-patient/" + slug);
      else history.push("/appointments/book");
    } else {
      setEmailVerify(true);
      if (followUpBooking) {
        return history.push("/appointment/select-patient/" + slug);
      }
    }
  };

  const setConsultDataFromFetch = (data) => {
    localStorage.setItem("doctorFeesData", JSON.stringify(data));
    setFees(data?.fees);
    setDuration(data?.duration?.label);
  };

  const getRedirectUrl = () => {
    if (!followUpBooking) {
      return "/appointments/book";
    } else return "/appointment/select-patient/" + slug;
  };

  const updateProcedures = (data, regularFollowupList = []) => {
    const reformattedData = data?.map((data) => {
      return {
        label: data.procedure_name,
        id: data.id,
        value: data.id,
      };
    });

    // for regular Followup List filter --
    const newProcedure = [];
    options.forEach((ele) => {
      let foundedElement = regularFollowupList.find(
        (obj) => obj.consultation_type == ele.id
      );
      if (foundedElement) {
        newProcedure.push(ele);
      }
    });
    let updatedProcedures = [...newProcedure, ...reformattedData];
    setProcedures(updatedProcedures);
    if (updatedProcedures?.length > 0) {
      handleprocedurechange(updatedProcedures[0]);
    } else {
      setselectedProcedure({});
      setProceduresValue({});
      setConsultationType("");
    }
  };

  const handleprocedurechange = (selectedOption) => {
    handleDate(new Date());
    if (
      selectedOption.value != "regular" &&
      selectedOption.value != "Follow-Up" &&
      selectedOption.value != "inclinic-regular" &&
      selectedOption.value != "inclinic-follow-up"
    ) {
      localStorage.setItem("procedure_consultation_type", "4");
      localStorage.setItem("procedure_id", selectedOption.id);
      setProcedureId(selectedOption.id);
      setSelectedConsultationType("");
      localStorage.removeItem("consultation-type");
      // setConsultationType(0) //newly added
      setProceduresValue(selectedOption);

      localStorage.removeItem("Tele_Consult_Follow_Up");
    } else {
      localStorage.removeItem("procedure_id");
      localStorage.setItem("procedure_consultation_type", selectedOption.id);
      setProcedureId("");
      setConsultationType(selectedOption?.id);
      setSelectedConsultationType(selectedOption.id);
      setProceduresValue(selectedOption);
      localStorage.setItem("consultation-type", selectedOption.id);
      if (selectedOption.value === "Follow-Up") {
        localStorage.setItem("Tele_Consult_Follow_Up", selectedOption.value);
      } else {
        localStorage.removeItem("Tele_Consult_Follow_Up");
      }
    }
    setselectedProcedure(selectedOption);
    if (selectedOption.value == "Follow-Up") {
      bookFollowup();
    }
  };

  const SelectClinicAndConsultationType = () => {
    const selectedOption = JSON.parse(
      sessionStorage.getItem("followUpConsultationType")
    );
    if (selectedOption) {
      localStorage.removeItem("procedure_id");
      localStorage.setItem("procedure_consultation_type", selectedOption.id);
      setProcedureId("");
      setConsultationType(selectedOption.id);
      setSelectedConsultationType(selectedOption.id);
      setProceduresValue(selectedOption);
      localStorage.setItem("consultation-type", selectedOption.id);
      localStorage.removeItem("Tele_Consult_Follow_Up");
      sessionStorage.removeItem("followUpConsultationType");
      sessionStorage.removeItem("followUpSelectdClinic");
    }
  };

  useEffect(() => {
    SelectClinicAndConsultationType();
    localStorage.removeItem("consultation-type");
  }, []);

  const handleInstruction = (data) => {
    setConsultationList(data.regular_followup_list);
    if (procedureId && procedureId != "") {
      data.procedure_list.map((data) => {
        if (data.id == procedureId) {
          setInstruction(data.instruction);
        }
      });
    } else {
      data.regular_followup_list.map((data) => {
        //consultation_type_list
        if (data.consultation_type == consultation_type) {
          setInstruction(data.instruction);
        }
      });
    }
  };

  useEffect(() => {
    if (isAssociated == "true") {
      let payload = {
        doctor_id: JSON.parse(localStorage.getItem("doctor"))?.doctor_id,
      };

      afterLoginApiAxios({
        method: "post",
        url: "/public/get-all-clinic-list-patient",

        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: payload,
      })
        .then((response) => {
          if (response.data.response == 200) {
            let list = [];
            const clinicOptions = [
              {
                clinic_name: response?.data?.personal_clinic_details
                  .doctor_clinic_name
                  ? response?.data?.personal_clinic_details.doctor_clinic_name
                  : "My Clinic",
                clinic_locality:
                  response?.data?.personal_clinic_details
                    ?.doctor_clinic_address,
                doctor_id: userId,
              },
            ];
            list = [
              {
                label: "OTHER CLINICS",
                options: response.data.clinc_list,
              },
              {
                label: "PERSONAL CLINIC",
                options: clinicOptions,
              },
            ];

            setClinicList(list);
          } else {
            if (response.data.message) {
              swal({
                title: "Error",
                text: response.data.message,
                type: "error",
                icon: "error",
                button: "OK",
              });
            }
          }
        })
        .catch((err) => C2CConsole.log(err));
    }
  }, [
    localStorage.getItem(LOCALSTORAGEKEY.IS_ASSOCIATED),
    JSON.parse(localStorage.getItem("doctor"))?.doctor_id,
  ]);

  const handleOnChange = (clinic) => {
    handleDate(new Date());
    setConsultationType("");
    setProcedures([]);
    if (clinic !== undefined && clinic !== null && clinic !== "") {
      setSelectedClinic(clinic);
      sessionStorage.setItem("selectedClinic", JSON.stringify(clinic));
      if (
        clinic.clinic_id !== undefined &&
        clinic.clinic_id !== null &&
        clinic.clinic_id !== ""
      ) {
        setDynamicCookieForUser(
          LOCALSTORAGEKEY.CLINIC_ID,
          clinic.clinic_id,
          setCookie
        );
        localStorage.setItem(LOCALSTORAGEKEY.CLINIC_ID, clinic.clinic_id);
      } else {
        setDynamicCookieForUser(LOCALSTORAGEKEY.CLINIC_ID, "", setCookie);
        localStorage.setItem(LOCALSTORAGEKEY.CLINIC_ID, "");
      }
    }
  };

  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          {props.selectProps.menuIsOpen ? (
            <i
              className="fa fa-caret-up"
              style={
                selectedClinic
                  ? { color: "black", fontSize: "18px" }
                  : { color: "lightgray", fontSize: "18px" }
              }
            ></i>
          ) : (
            <i
              className="fa fa-caret-down"
              style={
                selectedClinic
                  ? { color: "black", fontSize: "18px" }
                  : { color: "lightgray", fontSize: "18px" }
              }
            ></i>
          )}
        </components.DropdownIndicator>
      )
    );
  };
  return (
    <>
      <Header type="patient" {...props} redirect={true} />
      <LoginModal
        startTime={startTime}
        doctorDetails={doctor}
        selectedSlot={selectedSlot}
        appointmentDate={selectedDate}
        show={showLoginModal}
        loginSuccessHandler={loginSuccessHandler}
        hideModal={() => setShowLoginModal(false)}
        emailVerify={emailVerify}
      />
      <section className="pro-body-content">
        <div className="pro-content">
          <div className="container-fluid select-dt-wrapper patient-conatiner-div">
            <div
              className={
                "pro-content-col d-flex flex-column " +
                classes.doctorBookingPage
              }
            >
              <div className="m-0 row mb-3 doctor-heading-patient doc-profile">
                <div>
                  Welcome to C2C - an initiative to simplify healthcare for you.
                  You can
                  <b>&nbsp;book an online appointment </b> with the doctor by
                  selecting the date and time of your preference below. In case
                  you are looking for a
                  <b>
                    &nbsp;follow-up consultation, please book using the
                    ‘Follow-up’ option on the right.
                  </b>
                </div>
              </div>

              <div className="row m-0 pt-3">
                <DoctorDetails
                  duration={duration}
                  fees={fees}
                  setDoctorDetails={setDoctorDetails}
                  setalternateNumber={setalternateNumber}
                  updateProcedures={(data, regularFollowupList) =>
                    updateProcedures(data, regularFollowupList)
                  }
                  handleInstruction={handleInstruction}
                  selectedConsultationType={selectedConsultationType}
                  consultationList={consultationList}
                  instruction={instruction}
                  selectedClinic={selectedClinic}
                />
                <div
                  className={
                    "col-md-9 col-xs-12 book-appoint-block " +
                    classes.bookSchedule
                  }
                >
                  <div className="book-appoint-text appointment_type">
                    BOOK APPOINTMENT
                  </div>

                  <Stepper
                    active={1}
                    stepper={Steps.stepper[1]}
                    stepper_mob={Steps.stepper_mob[1]}
                  />
                  <div className="doctor-profile-right-section ">
                    <div
                      className="right-section-title-box"
                      style={{
                        borderBottom: "1px solid lightgray",
                        marginBottom: "5px",
                      }}
                    >
                      <div className={classes.consultationInfoRoot}>
                        {localStorage.getItem(LOCALSTORAGEKEY.IS_ASSOCIATED) ===
                        "true" ? (
                          <div
                            style={{
                              padding: "15px 25px",
                              width: "100%",
                              borderRight: "1px solid lightgray",
                            }}
                            className={classes.dropDown}
                          >
                            <div className=" d-flex ">
                              <SelectClinic
                                options={clinicList}
                                defaultValue={selectedClinic}
                                setSelectedClinic={setSelectedClinic}
                                noOptionsMessage={"No Clinic Found"}
                                handleOnChange={handleOnChange}
                              />
                            </div>
                          </div>
                        ) : (
                          ""
                        )}

                        <div
                          style={{
                            padding: "15px 25px",
                            width: "100%",
                            borderRight: "1px solid lightgray",
                          }}
                          className={classes.dropDown}
                        >
                          <div
                            className="d-flex "
                            style={{
                              cursor: "pointer",
                              justifyContent: "center",
                              alignItems: "center",
                              paddingTop: "5px",
                              paddingRight: "10px",
                            }}
                            onClick={() => setShowCalendar(!showCalendar)}
                          >
                            <span className="ml-1">
                              <img
                                src={CalendarClinicIcon}
                                alt="calender icon"
                                style={{
                                  color: "darkpink",
                                  paddingRight: "13px",
                                  paddingBottom: "2px",
                                }}
                              />
                            </span>
                            <div>
                              {" "}
                              <span
                                className="week-day"
                                style={{ fontWeight: "bold" }}
                              >
                                {moment(calenderDate).format("dddd,")}
                              </span>
                              <span
                                className=" ml-1"
                                // style={{ borderBottom: '1px dotted' }}
                                style={{ fontWeight: "bold" }}
                              >
                                {moment(calenderDate).format("DD MMM, YYYY")}
                              </span>
                            </div>

                            <span className="ml-1">
                              <img src={DropdownIcon} alt="calender arrow" />
                            </span>
                          </div>
                          <div
                            className="doctor-profile-right-section-calender"
                            style={{ width: "85" }}
                          >
                            <Calendar
                              className={showCalendar ? "" : "hide"}
                              onChange={handleDate}
                              value={calenderDate}
                              minDate={new Date()}
                              maxDate={moment(new Date()).add(12, "months")._d}
                              // className="calendar-view"
                            />
                          </div>
                        </div>

                        {localStorage.getItem(LOCALSTORAGEKEY.IS_ASSOCIATED) ===
                        "true" ? (
                          <div
                            className={"patient-side-procedure "}
                            style={{
                              padding: "15px 25px",
                              width: "100%",
                            }}
                          >
                            <div className="d-flex ">
                              {selectedClinic ? (
                                <img
                                  src={ConsultationClinicIcon}
                                  alt="clinicIcon"
                                  style={{ width: 22 }}
                                />
                              ) : (
                                <img
                                  src={disableIcon}
                                  alt="clinicIcon"
                                  style={{ width: 22 }}
                                />
                              )}
                              <Select
                                className="select_procedure"
                                classNamePrefix="patient-side-procedure"
                                name="patient-side-procedure"
                                styles={styles}
                                value={proceduresValue}
                                isDisabled={!selectedClinic ? true : false}
                                // value={this.state.selectedOption}
                                onChange={handleprocedurechange}
                                options={procedures}
                                // onBlur={this.handleBlur}
                                // styles={customStyles}
                                placeholder="Select Consultation"
                                components={{
                                  DropdownIndicator: DropdownIndicator,
                                  IndicatorSeparator: () => null,
                                }}
                                theme={(theme) => ({
                                  ...theme,
                                  borderRadius: "5px",
                                  colors: {
                                    ...theme.colors,
                                    primary25: "#fff",
                                    primary: "#5AD5F2",
                                  },
                                })}
                                isSearchable={procedures?.length > 0}
                              />
                            </div>
                          </div>
                        ) : (
                          <div
                            className={"patient-side-procedure "}
                            style={{ padding: "15px 25px", width: "100%" }}
                          >
                            <div className="d-flex ">
                              <img
                                src={ConsultationClinicIcon}
                                alt="clinicIcon"
                                style={{ width: 22 }}
                              />
                              <Select
                                className="select_procedure"
                                classNamePrefix="patient-side-procedure"
                                name="patient-side-procedure"
                                styles={styles}
                                // defaultValue={procedures}
                                // isDisabled={!selectedClinic ? true : false}
                                value={proceduresValue}
                                onChange={handleprocedurechange}
                                options={procedures}
                                // onBlur={this.handleBlur}
                                // styles={customStyles}
                                placeholder="Select Consultation"
                                components={{
                                  DropdownIndicator: DropdownIndicator,
                                  IndicatorSeparator: () => null,
                                }}
                                theme={(theme) => ({
                                  ...theme,
                                  borderRadius: "5px",
                                  colors: {
                                    ...theme.colors,
                                    primary25: "#fff",
                                    primary: "#5AD5F2",
                                  },
                                })}
                                isSearchable={procedures?.length > 0}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {(selectedClinic && isAssociated === "true") ||
                    isAssociated === "false" ? (
                      <>
                        <div className="mx-4 pl-2 mb-4 pt-4">
                          <b>INSTRUCTIONS :</b> {instruction}
                        </div>

                        <BookSchedule
                          // consultType={0}
                          consultType={
                            consultation_type == 1 ? 0 : consultation_type
                          }
                          // ref_id={consultation_type}
                          hideAnnotation
                          track={track}
                          selectedProcedure={selectedProcedure}
                          selectedClinic={selectedClinic}
                          fromCalender={fromCalender}
                          calenderDate={calenderDate}
                          setConsultData={setConsultDataFromFetch}
                          alternateNumber={alternateNumber}
                          doctorSlug={slug}
                          setStartTime={(e) => {
                            if (e) {
                              localStorage.setItem("time", e);
                              setStartTime(e);
                            }
                          }}
                          doctorId={doctor?.doctor_id}
                          doctor={doctor}
                          onDateSelect={(e) => {
                            setCalenderDate(e.meta._d);
                            if (e) {
                              setSelectedDate(e);
                              localStorage.setItem(
                                "date",
                                moment(e.meta).format("YYYY-MM-DD")
                              );
                            }
                          }}
                          onSlotSelect={(e) => {
                            if (e) {
                              setSelectedSlot(e);
                              localStorage.setItem("slot_id", e);
                            }
                          }}
                          setCounter={setCounter}
                          bookFollowUp={bookFollowUp}
                          handleInstruction={handleInstruction}
                          handleDate={handleDate}
                          procedures={procedures}
                        />
                      </>
                    ) : (
                      <div id="foto" style={{ textAlign: "center" }}>
                        <img
                          src={clinic}
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "80px",
                          }}
                          alt="calender icon"
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="text-right w-100"></div>
              </div>
            </div>
          </div>
          <button className="book-appoint-video-btn">
            <a
              href=""
              data-toggle="modal"
              data-target="#myModal"
              className="book-appoint-video"
              onClick={startVideo}
            >
              <img
                src={
                  process.env.PUBLIC_URL + "/images/how-to-book-video-play.svg"
                }
                alt=""
              />
              <span>How to book appointment</span>
            </a>
          </button>
        </div>
      </section>

      <section className="video-col2 appoint-footer-banner">
        <div className="container">
          <div className="row">
            <div className="col-md-7 col-xs-12 order-md-1 order-sm-2 banner-text">
              <p>
                Login to Connect2Clinic to consult with your trusted doctors
                from the safety of your home.
              </p>
              <div className="banner-subtext">
                <a
                  href=""
                  data-toggle="modal"
                  data-target="#myModal"
                  className="book-appoint-video"
                  onClick={startVideo}
                >
                  <img
                    src={process.env.PUBLIC_URL + "/images/howItWorksPlay.svg"}
                    alt=""
                  />
                  <span>How It Works</span>
                </a>
              </div>
            </div>
            <div className="col-md-5 col-xs-12 order-md-2 order-sm-1 banner-image">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/appointment-footer-banner.png"
                }
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
      <LinkExpiredModal
        show={isLinkExpired}
        slug={slug}
        onHide={() => {
          setIsLinkExpired(false);
        }}
      />

      <div
        className="modal"
        id="myModal"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg video-modal">
          <div className="modal-content">
            <div className="modal-header"> </div>
            <div className="modal-body video_content">
              <button
                type="button"
                className="video-close"
                data-dismiss="modal"
                onClick={stopVideo}
              >
                <img src={CloseIcon} alt="#" />
              </button>
              <iframe
                width="1280"
                src={videoUrl}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showPatientLoginModal}
        onHide={() => {
          setShowPatientLoginModal(false);
        }}
      >
        <Modal.Body>
          {meetingId ? null : (
            <button
              type="button"
              className="video-close"
              data-dismiss="modal"
              onClick={() => {
                localStorage.removeItem("meeting_id");
                setShowPatientLoginModal(false);
              }}
              style={{
                float: "right",
                position: "absolute",
                top: "15px",
                right: "20px",
              }}
            >
              <img className="" src={CloseIcon} />
            </button>
          )}

          <div className="d-flex flex-row align-items-center justify-content-center w-100 py-3">
            <PatientLoginContainer
              loginSuccessHandler={loginSuccessHandler}
              closeModal={() => {
                setShowPatientLoginModal(false);
              }}
              redirectUrl={getRedirectUrl()}
            />
          </div>
        </Modal.Body>
      </Modal>

      {selectedSlot && !showLoginModal ? (
        <div className="w-100 mobileFixedBook continue-btn-outer">
          <div style={{ textAlign: "center", width: "100%" }}>
            <button
              disabled={!selectedSlot}
              className={classes.submitButton}
              onClick={bookAppointment}
              ref={bookingButtonRef}
            >
              Continue
              <img
                src={process.env.PUBLIC_URL + "/images/right-arrow.png"}
                alt=""
                className="book-appoint-arrow"
              />
            </button>
          </div>
        </div>
      ) : null}

      <GlobalFooter />
    </>
  );
};

const mapStateToProps = (state) => ({
  mobileNumber: state.global.mobileNumber,
  emailId: state.global.emailId,
});
export default connect(mapStateToProps)(UserBrowser(DoctorProfile));
